require('./tppKeyConsentHistory.scss');
import { ContentBox } from 'commonsComponents/contentBox';
const PropTypes = require('prop-types');
const React = require('react');
const moment = require('moment');

// @ commons
const { EmptyState } = require('commonsComponents/emptyState');
const { OKTable } = require('commonsComponents/OKTable');

// @ constants
const { DATE_FORMAT_ES, TPP_RECURRENT_TYPE } = require('constants/index');
const {
    CONSENT_STATUS_VALID,
    CONSENT_STATUS_VALIDATED,
    CONSENT_STATUS_RECEIVED,
    CONSENT_STATUS_REJECTED,
    CONSENT_STATUS_EXPIRED,
    CONSENT_STATUS_REVOKEDBYPSU,
    CONSENT_STATUS_TERMINATEDBYTPP
} = require('constants/tpps');

//@helpers
const { FormattedText } = require('core/i18n').i18n;
const { formatText } = require('core/i18n').i18n;


const TppKeyConsentHistoryTableHeader = require('components/myProfile/tppKeysComponents/tppKeyConsentHistory/tppKeyConsentHistoryTableHeader/tppKeyConsentHistoryTableHeader');
const TppKeyConsentHistoryTableRow = require('components/myProfile/tppKeysComponents/tppKeyConsentHistory/tppKeyConsentHistoryTableRow/tppKeyConsentHistoryTableRow');
const { LoadingSection } = require('commonsComponents/loadingSection');

export default function TppKeyConsentHistory(props) {

    function buildTableHead() {
        const tableHeadContent = (
            <thead>
                <TppKeyConsentHistoryTableHeader />
            </thead>
        );

        return tableHeadContent;
    }

    function buildTableBody(allConsents) {
        if(allConsents && allConsents.size > 0) {
            return allConsents.map((consent, index) => {
                const consentStatus = buildConsentState(consent.get('consentStatus').toLowerCase());
                const consentRecurringIndicator = buildConsentRecurrentType(consent.get('recurrentType'));
                const consentRecordDate = consent.get('creationDate');
                const activationDate = !consentRecordDate ? '-' : moment(consentRecordDate).format(DATE_FORMAT_ES);

                return (
                    <TppKeyConsentHistoryTableRow
                        key={index}
                        activationDate={activationDate}
                        consentRecurringIndicator={consentRecurringIndicator}
                        consentStatus={consentStatus}
                    />
                );
            });
        } else {
            <LoadingSection/>
        }
    }

    function buildConsentRecurrentType(consentRecurringIndicator) {
        if(typeof consentRecurringIndicator === 'undefined') return '-';
        const recurrentType = consentRecurringIndicator === TPP_RECURRENT_TYPE
            ? <FormattedText value="keysTppView-consentRecurrent" />
            : <FormattedText value="keysTppView-consentNotRecurrent" />;
        return recurrentType;
    }

    function buildConsentState(consentState) {
        var status;
        switch(consentState){
            case CONSENT_STATUS_VALID:
            case CONSENT_STATUS_VALIDATED: status = <FormattedText value="keysTppView-consentStatusValid" />; break;
            case CONSENT_STATUS_RECEIVED:  status = <FormattedText value="keysTppView-consentStatusReceived" />; break;
            case CONSENT_STATUS_REJECTED: status = <FormattedText value="keysTppView-consentStatusRejected" />; break;
            case CONSENT_STATUS_EXPIRED: status = <FormattedText value="keysTppView-consentStatusExpired" />; break;
            case CONSENT_STATUS_REVOKEDBYPSU: status = <FormattedText value="keysTppView-consentStatusRevokedByPsu" />; break;
            case CONSENT_STATUS_TERMINATEDBYTPP: status = <FormattedText value="keysTppView-consentStatusTerminatedByTpp" />; break;

            default: status = '-';
        }
        return status;
    }
    const { allConsents } = props;
    const tableBodyBlock = buildTableBody(allConsents);
    const headerTitle = formatText('keysTppView-consentHistoryTableHeader');
    const tableHead = buildTableHead();

    let content = (
        <article>
            <OKTable>
                {tableHead}
                {tableBodyBlock}
            </OKTable>
        </article>
    );
    
    return (
        <div className="tpp-key-detail-info-consent-history__container">
            <ContentBox>
                <div className="tpp-key-detail-info-consent-history__title">
                    {headerTitle}
                </div>
                <div className="tpp-key-detail-info-consent-history__separator"></div>
                {content}
            </ContentBox>
        </div>
    );
}

